import { Card, Space, Button } from "antd";
import { useState } from "react";
import { trackSpecCloudAccountInit } from "../backend/tracking/user-settings";
import CloudIcon from "./CloudIcon";
import ConnectExoscaleAccountModal from "./settings/ConnectExoscaleAccountModal";
import ChooseExoscaleAccountCard from "./ChooseExoscaleAccountCard";

interface ExoscaleAccountSelectProps {
    disabled?: boolean;
    selectedAccount?: {
        exoscaleAccountId?: string;
        exoscaleZone?: string;
    };
    exoscaleAccounts: { id: string, name: string }[];
    errorClassName?: string;
    onSelect?: ({ exoscaleAccountId, exoscaleZone }: { exoscaleAccountId: string; exoscaleZone: string; }) => void;
}

const ExoscaleAccountSelect = ({
    onSelect,
    selectedAccount,
    disabled,
    errorClassName,
    exoscaleAccounts,
}: ExoscaleAccountSelectProps) => {
    const [modalVisible, setModalVisible] = useState(false);
    const classNames = [disabled ? "ant-card-disabled" : "", errorClassName || ""].join(" ");

    return (
        <>
            {
                selectedAccount?.exoscaleAccountId || selectedAccount?.exoscaleZone || exoscaleAccounts.length > 0 ?
                    <ChooseExoscaleAccountCard
                        classNames={classNames}
                        exoscaleAccounts={exoscaleAccounts}
                        selectedAccount={selectedAccount}
                        onSelect={onSelect}
                    />
                    :
                    <Card type="inner" className={classNames} >
                        <Card.Meta title="Exoscale Account" description="Configure the Exoscale account for the selected environment." />
                        <br />
                        <Space direction="vertical">
                            <Button
                                onClick={() => {
                                    setModalVisible(true);
                                    trackSpecCloudAccountInit("exoscale");
                                }}
                            >
                                <Space>
                                    <CloudIcon provider="exoscale" /> Connect Exoscale Account
                                </Space>
                            </Button>
                        </Space>
                    </Card>
            }
            {
                // Workaround. The modal is not unmouting when closed so we need to unmount the whole component using 'modalVisible'
                // We have a process of periodic API calls which remain active even if when the modal closes
                modalVisible &&
                <ConnectExoscaleAccountModal
                    visible={modalVisible}
                    onOk={(id) => {
                        setModalVisible(false);
                        onSelect?.({ exoscaleAccountId: id, exoscaleZone: "" });
                    }}
                    onCancel={() => setModalVisible(false)}
                />
            }
        </>
    );
}

export default ExoscaleAccountSelect;

